exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.card-height-2[data-v-2481efae] {\n  height: 350px;\n}\n.fs-super-big[data-v-2481efae] {\n  font-size: 3rem;\n}\n.dateRangePicker[data-v-2481efae] {\n  min-width: 250px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2481efae","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/Reports.vue
// module id = 2907
// module chunks = 0